import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const RecentSearchSkeleton = () => {
  return (
    <div>
      <Row className="mb-3">
        <Col>
          <Skeleton height={20} width={80} count={1} />
        </Col>
        <Col className="text-right">
          <Skeleton
            height={20}
            width={60}
            count={1}
            containerClassName={'mr-5'}
          />
        </Col>
      </Row>
      <div>
        <Skeleton height={45} width={'100%'} count={5} />
      </div>
      <div className="mt-3">
        <Skeleton height={20} width={70} count={1} />
      </div>
    </div>
  );
};

export default RecentSearchSkeleton;
